import styled from 'styled-components'

export default styled.div`
	h1,
	h2,
	h3,
	h4,
	h5,
	h6,
	p:first-of-type {
		margin: 0;
	}

	ul {
		list-style: disc;

		li {
			margin-bottom: 10px;
		}
	}
`
